module.exports = __webpack_public_path__ + "img/goldregen-2020-127.7499e677.jpg";